import { router } from '../../app';
import { store } from '../';
import  moment from 'moment';
import Vue from 'vue'

const state = () => ({
    userReports: {

    },
    defaultReports: {
        invitem: {
            model:"Invitem",
            columns: {},
            availableColumns: [],
            textFilter: '',
            page: 0,
            data: [],
            results: null,
            selectedFacets: [],
            sorts: {},
            updated: null,
            name: '',
            selectionMode: 'none',
            title: 'All Inventory Items',
            reportButtons: [
                {action: 'ship-box', label: 'Ship Box Now!', class: 'btn-success' }
            ],
            rowActions: [
                {action: 'print-label', label: 'Print Label'}
            ]
        }
    }
});

const getters = {
    latestReport: state => {
        if(Object.keys(state.userReports).length == 0){
            return null;
        }else if(Object.keys(state.userReports).length == 1){
            return Object.values(state.userReports)[0];
        }else{
            return Object.values(state.userReports).sort((a,b) => {
                if (a.updated > b.updated) return -1;
                if (a.updated < b.updated) return 1;
                return 0;
            })[0];
        }
    },
    reportByName: (state, name) => {
        return state.userReports[name];
    },
    defaultReport: state => state.defaultReports.invitem
};

const mutations = {
    saveReport(state, report){
        report.updated = moment().format();
        var reportObj = {};
        reportObj[report.name] = report;
        state.userReports = { ...reportObj, ...state.userReports}
    }
};

const actions = {
    saveReport({commit, state}, report){
        commit('saveReport', report);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
